<template lang="pug">
.bems-event-card.z-depth-2.card
  .bems-card-header
    p {{ product.title }}
  .bems-card-img
    img(:src="product.image" :alt="product.desc")
  .bems-card-content
    h4 ${{ product.price }}
    p {{ product.desc }}
    div.charity-info
      p We will donate 30% of the profit from this sale to the selected charity.
      select(v-model="charity" @change="$emit('selectedCharity', charity)")
        option(selected value="") Choose a Charity
        option(v-for="charity in charities" :value="charity.name") {{charity.name}}
    a.btn.btn-large(@click="$emit('selectedProduct', product)") Reserve
  .bems-card-footer.z-depth-1
</template>

<script>
import { db } from '../firebase-config.js'

export default{
  props: ['product'],
  data () {
    return {
      charity: ''
    }
  },
  firebase () {
    return {
      deals: db.ref('deals'),
      charities: db.ref('give')
    }
  }
}
</script>

<style scoped lang="stylus">

.chip
  background-color #555
  color #fff

.deal-name
  font-weight bold
  font-size x-large

.charity-info
  width 100%
  height 100%
  margin 0
  padding 1em
  p
    padding 0 !important

.bems-event-card
  display flex
  float left
  position relative
  flex-direction column
  justify-content space-between
  width 300px
  @media screen and (max-width: 350px)
    width auto
  margin 1em
  border-radius 1em
  overflow hidden
  .bems-card-header, .bems-card-footer
    display flex
    align-items center
    padding 0 1em
    p
      text-transform capitalize
      font-size large
      font-weight bold
      color white
  .bems-card-content
    color #fff
    p
      padding 1em
    a
      height 40px
      margin 0
      padding 0
      border-radius 0
      font-weight bold
    h4
      position relative
      top -80px
      float right
      font-size 3em
      font-weight bold
      padding-right 20px
      font-family lobster
    .bems-card-img
      img
        width 100%
    .bems-card-header
      justify-content center
      font-weight bold
      font-size 20px
</style>
